/**
 * Definition of available themes. This string value will be stored in
 * localStorage for maintenance of local preferences.
 */
export const Theme = {
  LIGHT: 'light',
  DARK: 'dark',
};
